export default "__VITE_ASSET__JYXrRKmbxySHtvJ4O0q1Zw__"